import {createStore} from 'vuex'
import {setSectionPath} from "@/store/sesssion";

export enum stateMutationType {
  SET_SECTIONID_MUTATION = 'SET_SECTIONID_MUTATION',
  SET_DEVICETYPE_MUTATION = 'SET_DEVICETYPE_MUTATION',
  SET_PATH_MUTATION = 'SET_PATH_MUTATION'
}

export enum stateActionType {
  SET_SECTIONID_ACTION = 'SET_SECTIONID_ACTION',
  SET_DEVICETYPE_ACTION = 'SET_DEVICETYPE_ACTION',
  SET_PATH_ACTION = 'SET_PATH_ACTION'
}

export interface MainStates {
  sectionId: string
  deviceType: string
  path:string
}


const useStore = () => {
  return createStore<MainStates>({
    state: {
      sectionId: '1',
      deviceType: '1',//1 pc 2 手机
      path:'',
    },
    mutations: {
      [stateMutationType.SET_SECTIONID_MUTATION](state, obj: { sectionId: string }) {
        state.sectionId = obj.sectionId

      },
      [stateMutationType.SET_DEVICETYPE_MUTATION](state, obj: { deviceType: string }) {
        state.deviceType = obj.deviceType
      },
      [stateMutationType.SET_PATH_MUTATION](state, obj: { path: string }) {
        state.path = obj.path
        setSectionPath(obj.path)
      },
    },
    actions: {
      [stateActionType.SET_SECTIONID_ACTION]( // 设置当前所在章节
        {commit},
        obj: { sectionId: string }
      ) {
        commit(stateMutationType.SET_SECTIONID_MUTATION, obj)
      },
      [stateActionType.SET_DEVICETYPE_ACTION]( // 设置当前所在章节
        {commit},
        obj: { deviceType: string }
      ) {
        commit(stateMutationType.SET_DEVICETYPE_MUTATION, obj)
      },
      [stateActionType.SET_PATH_ACTION]( // 设置当前所在章节
        {commit},
        obj: { path: string }
      ) {
        commit(stateMutationType.SET_PATH_MUTATION, obj)
      },
    },
  })
}
export default useStore
